import { EllipsisVerticalIcon, TrashIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button, Card, CardContent, PermissionGuard } from "@/components";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useI18n } from "@/context/i18n";
import { usePermissions } from "@/context/permissions";

import { TUser } from "../users.types";

export const TablesUsers = ({ users = [], onDelete }: { users: TUser[]; onDelete?: (id: string) => void }) => {
  const { t } = useI18n();
  const { hasAnyPermission } = usePermissions();
  const navigate = useNavigate();

  // Verificar se o usuário tem pelo menos uma permissão para ações
  const hasActionPermissions = hasAnyPermission(["user:update", "user:delete"]);
  return (
    <Card className="p-4">
      <CardContent>
        {users.length === 0 && (
          <div className="flex flex-col items-center justify-center h-full">
            <p className="text-muted-foreground">{t("users.no_users")}</p>
          </div>
        )}
        {users.length > 0 && (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nome</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Documento</TableHead>
                <TableHead>Criado em</TableHead>
                {hasActionPermissions && (
                  <TableHead>Ações</TableHead>
                )}
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((user, i) => (
                <TableRow key={i}>
                  <TableCell>
                    {user.first_name} {user.last_name}
                  </TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.document}</TableCell>
                  <TableCell>
                    {new Date(user.created_at).toLocaleDateString("pt-BR")}
                  </TableCell>
                  {hasActionPermissions && (
                    <TableCell>
                      <PermissionGuard
                        permissions={["user:update", "user:delete"]}
                        requireAll={false}
                      >
                        <DropdownMenu>
                          <DropdownMenuTrigger asChild>
                            <Button size={"sm"} variant={"ghost"}>
                              <EllipsisVerticalIcon className="h-4 w-4" />
                            </Button>
                          </DropdownMenuTrigger>
                          <DropdownMenuContent>
                            <PermissionGuard permission="user:update">
                            <DropdownMenuItem
                              onSelect={() => navigate(`/team-form?id=${user.id}`)}
                            >
                                {t("generic.edit")}
                              </DropdownMenuItem>
                            </PermissionGuard>
                            <PermissionGuard permission="user:delete">
                              <DropdownMenuItem
                                className="bg-red-400"
                                onSelect={() => onDelete?.(user.id)}
                              >
                                <TrashIcon className="h-4 w-4 mr-2" />
                                {t("generic.delete")}
                              </DropdownMenuItem>
                            </PermissionGuard>
                          </DropdownMenuContent>
                        </DropdownMenu>
                      </PermissionGuard>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
